import React from 'react';
import TableBoolean from '../../components/Table/TableBoolean/TableBoolean';

const headerStyle = () => {
    return {
        borderColor: '#a81933'
    };
};

const columnStyle = () => {
    return {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
    };
};

export const columns = [
    {
        dataField: 'name',
        text: 'Name',
        sort: true,
        headerStyle: () => { return { width: '12%', ...headerStyle() }; },
        style: columnStyle
    },
    {
        dataField: 'active',
        text: 'Status',
        sort: true,
        formatter: (_cell, row) => <TableBoolean value={row.statusId === 1} text={row.statusName} />,
        headerStyle: () => { return { width: '100px', ...headerStyle() }; }
    },
    {
        dataField: 'redName',
        text: 'Feed Alias',
        sort: true,
        headerStyle: headerStyle,
        style: columnStyle
    },
    {
        dataField: 'homeSmartName',
        text: 'HS Name',
        sort: true,
        headerStyle: headerStyle,
        style: columnStyle
    },
    {
        dataField: 'stateName',
        text: 'State',
        sort: true,
        headerStyle: headerStyle,
        style: columnStyle
    },
    {
        dataField: 'officesFee',
        text: 'Offices Feed',
        sort: true,
        formatter: (_cell, row) => <TableBoolean value={row.officesFeed} />,
        headerStyle: () => { return { width: '7%', ...headerStyle() }; },
    },
    {
        dataField: 'agentsFeed',
        text: 'Agents Feed',
        sort: true,
        formatter: (_cell, row) => <TableBoolean value={row.agentsFeed} />,
        headerStyle: () => { return { width: '7%', ...headerStyle() }; },
    },
    {
        dataField: 'soldFeed',
        text: 'Sold Feed',
        sort: true,
        formatter: (_cell, row) => <TableBoolean value={row.soldFeed} />,
        headerStyle: () => { return { width: '7%', ...headerStyle() }; },
    },
    {
        dataField: 'comingSoonFeed',
        text: 'Coming Soon Feed',
        sort: true,
        formatter: (_cell, row) => <TableBoolean value={row.comingSoonFeed} />,
        headerStyle: () => { return { width: '11%', ...headerStyle() }; },
    }
];

export const sorting = [{
    dataField: 'name',
    order: 'asc'
}];